import * as React from 'react';

import { Col, Form, FormProps, Input, Row } from 'antd';
import { IdcardFilled, LockFilled, LoginOutlined } from '@ant-design/icons';

import { AppButton } from '@/components/appButton';
import { nameof } from 'ts-simple-nameof';
import { useTranslation } from 'react-i18next';

interface LoginFormValues {
    username: string;
    password: string;
}

interface LoginFormProps extends FormProps<LoginFormValues> {
    isLoading?: boolean;
}

export const LoginForm: React.VFC<LoginFormProps> = (props) => {
    const { t } = useTranslation();
    const [form] = Form.useForm<LoginFormValues>();

    const { isLoading, ...formProps } = props;

    return (
        <Form
            style={{ marginTop: '20px', alignSelf: 'center', ...formProps.style }}
            layout="vertical"
            {...formProps}
            form={form}
        >
            <Form.Item
                required={true}
                label={t('Components.Forms.LoginForm.username_label')}
                rules={[{ required: true }]}
                name={nameof<LoginFormValues>(x => x.username)}
            >
                <Input
                    disabled={isLoading}
                    autoComplete="username"
                    prefix={<IdcardFilled />}
                    placeholder={t('Components.Forms.LoginForm.username_placeholder')}
                />
            </Form.Item>

            <Form.Item
                required={true}
                label={t('Components.Forms.LoginForm.password_label')}
                rules={[{ required: true }]}
                name={nameof<LoginFormValues>(x => x.password)}
            >
                <Input.Password
                    type="password"
                    disabled={isLoading}
                    autoComplete="drawbridge-password"
                    prefix={<LockFilled />}
                    placeholder={t('Components.Forms.LoginForm.password_placeholder')}
                />
            </Form.Item>

            <Row
                align="middle"
                justify="center"
            >
                <Col>
                    <AppButton
                        htmlType="submit"
                        size="middle"
                        style={{ alignSelf: 'flex-end' }}
                        icon={<LoginOutlined />}
                        disabled={isLoading}
                        loading={isLoading}
                    >
                        {t('Components.Forms.LoginForm.login_button_text')}
                    </AppButton>
                </Col>
            </Row>
        </Form>
    );
};